import React from 'react';
import { ICON_MAP, EMOJI_TO_ICON } from './iconRegistry';

const Icon = ({
  name,
  size = 24,
  className = '',
  strokeWidth = 2,
  ...props
}) => {
  const resolvedName = ICON_MAP[name]
    ? name
    : EMOJI_TO_ICON[name] || 'circle';
  const IconComponent = ICON_MAP[resolvedName] || ICON_MAP.circle;

  return (
    <IconComponent
      size={size}
      className={className}
      strokeWidth={strokeWidth}
      aria-hidden="true"
      {...props}
    />
  );
};

export default Icon;
